import React from 'react';
import { Route } from 'react-router-dom';
import StudentEnrollments from '../pages/studentEnrollments/StudentEnrollments';
import CreateStudentEnrollment from '../pages/studentEnrollments/CreateStudentEnrollment';
import EditStudentEnrollment from '../pages/studentEnrollments/EditStudentEnrollment';
import PermissionGuard from '../components/global/PermissionGuard';

const studentEnrollmentsRoutes = (
    <>
        <Route path="/student-enrollments" element={<PermissionGuard permission="student_enrollments_list"><StudentEnrollments /></PermissionGuard>} />
        <Route path="/student-enrollments/create" element={<PermissionGuard permission="student_enrollments_create"><CreateStudentEnrollment /></PermissionGuard>} />
        <Route path="/student-enrollments/:id/edit" element={<PermissionGuard permission="student_enrollments_edit"><EditStudentEnrollment /></PermissionGuard>} />
    </>
);

export default studentEnrollmentsRoutes;
